import { trackError } from '@billy/track-error'

const AIIA_HUB_URL = window.ENV ? window.ENV.AIIA_HUB_URL : undefined
export const redirectToAiia = () => {
  if (AIIA_HUB_URL) {
    window.open(AIIA_HUB_URL, '_blank', 'noopener,noreferrer')
  } else {
    trackError('AIIA_HUB_URL is not defined in your ENV variables')
  }
}
